module.exports = __webpack_public_path__ + "img/微信公众号.de7e0805.png";